module.exports = __webpack_public_path__ + "img/card3.9950ec46.png";